import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import axiosInstance from "../../../../services/axiosInstance";
import BookToc from "./BookToc";
import { Video } from "../../../imagepath";
import { pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusNot, pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusNotMinusOne } from "../../../../services/publicationService"; // yolu seninkine göre düzelt
import { getFilePath } from "../../../../services/axiosInstance";

// ---- Attribute helpers (dil & boşluk dayanıklı) ----
function pickFrom(list = [], name, lang = "tr") {
    const info = list.find(a => a.attributename === name);
    if (!info || !Array.isArray(info.value)) return null;

    const langHit = info.value.find(v => v.lang === lang && Array.isArray(v.value) && v.value[0]);
    const firstHit = info.value.find(v => Array.isArray(v.value) && v.value[0]);

    const raw = (langHit?.value?.[0] ?? firstHit?.value?.[0]) ?? null;
    const str = (raw !== null && raw !== undefined) ? String(raw).trim() : null;
    return str || null;
}
function pickFromArr(list = [], name, lang = "tr") {
    const info = list.find(a => a.attributename === name);
    if (!info || !Array.isArray(info.value)) return null;

    const langHit = info.value.find(v => v.lang === lang && Array.isArray(v.value) && v.value.length);
    const firstHit = info.value.find(v => Array.isArray(v.value) && v.value.length);

    const rawArr = (langHit?.value ?? firstHit?.value) ?? null;
    if (!rawArr) return null;
    const cleaned = rawArr.map(x => String(x).trim()).filter(Boolean);
    return cleaned.length ? cleaned : null;
}
function getAttr(publication, name, lang = "tr") {
    if (!publication) return null;
    return (
        pickFrom(publication.publicationtypeInfo, name, lang) ??
        pickFrom(publication.templateInfo, name, lang) ??
        null
    );
}
function getAttrArr(publication, name, lang = "tr") {
    if (!publication) return null;
    return (
        pickFromArr(publication.publicationtypeInfo, name, lang) ??
        pickFromArr(publication.templateInfo, name, lang) ??
        null
    );
}

function nonZeroOrNull(val) {
    if (val === null || val === undefined) return null;
    const n = parseInt(String(val).replace(/[^\d]/g, ""), 10);
    return Number.isFinite(n) && n > 0 ? String(val).trim() : null;
}


// HTML -> düz metin
function htmlToPlain(html) {
    if (!html || typeof html !== "string") return null;
    // satır sonlarını koru
    const withBreaks = html
        .replace(/<\s*br\s*\/?>/gi, "\n")
        .replace(/<\/\s*p\s*>/gi, "\n\n")
        .replace(/<\s*p[^>]*>/gi, "");
    // tüm etiketleri at
    const textOnly = withBreaks.replace(/<[^>]+>/g, "");
    // entity çöz
    if (typeof window !== "undefined") {
        const div = document.createElement("div");
        div.innerHTML = textOnly;
        return (div.textContent || div.innerText || "").trim();
    }
    // SSR için basit fallback
    return textOnly
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .trim();
}


const BookAbout = ({ publication, similarPublications, authToken, navigate, initialMainTab = "about", pubtype }) => {
    // Özet (HTML olabilir)
    const summaryHtml = getAttr(publication, "Özet");

    // Künye alanları (değer varsa gösterilecek)
    const isbn = getAttr(publication, "ISBN");
    const eisbn = getAttr(publication, "E-ISBN");
    const doi = getAttr(publication, "DOI");
    const volume = getAttr(publication, "Cilt");
    const pageCount = getAttr(publication, "Sayfa Sayısı") || getAttr(publication, "Sayfalar");
    const pubDate = getAttr(publication, "Yayın Tarihi")?.substring(0, 4);
    const language = getAttr(publication, "Yayın Dili");
    const country = getAttr(publication, "Ülke");
    const printInfo = getAttr(publication, "Baskı Bilgisi");
    const editor = getAttr(publication, "Editör");
    const preparedBy = getAttr(publication, "Yayına Hazırlayan");
    const keywordsRaw = [
        ...(pickFromArr(publication?.publicationtypeInfo, "Anahtar Kelimeler") || []),
        ...(pickFromArr(publication?.publicationtypeInfo, "Konu Başlıkları") || []),
        ...(pickFromArr(publication?.templateInfo, "Konu Başlıkları") || []),
        ...(pickFromArr(publication?.templateInfo, "Anahtar Kelimeler") || []),
    ];
    const keywords = Array.from(new Set(keywordsRaw.map(x => String(x).trim()).filter(Boolean)));
    // Dinamik Özet Keşfi (TR, EN, AR vb.)
    const ozetAttr = [...(publication?.publicationtypeInfo || []), ...(publication?.templateInfo || [])]
        .find(a => a.attributename === "Özet");
    
    const availableSummaries = (ozetAttr?.value || [])
        .filter(v => Array.isArray(v.value) && v.value[0])
        .map(v => ({
            lang: String(v.lang || "tr").toLowerCase(),
            text: htmlToPlain(v.value[0])
        }))
        .filter((v, i, a) => a.findIndex(t => t.lang === v.lang) === i);

    const defaultLang = availableSummaries.find(s => s.lang === "tr")?.lang || availableSummaries[0]?.lang || "tr";
    const [activeSummaryTab, setActiveSummaryTab] = useState(defaultLang);
    const [hoverLeft, setHoverLeft] = useState(false);
    const [hoverRight, setHoverRight] = useState(false);
    const activeSummary = availableSummaries.find(s => s.lang === activeSummaryTab) || availableSummaries[0];


    // Seri / Alt Seri alanları (varsa gösterilecek)
    const seriesName = getAttr(publication, "Seri Adı");
    const seriesNumber = getAttr(publication, "Seri Numarası");
    const subseriesName = getAttr(publication, "Alt Seri Adı");
    const subseriesNumber = getAttr(publication, "Alt Seri Numarası");

    const [bookmarks, setBookmarks] = useState([]);
    const sliderRef = useRef(null);

    const scrollSlider = (direction) => {
        const slider = sliderRef.current;
        if (!slider) return;
        const amount = 200; // kayma mesafesi
        slider.scrollBy({
            left: direction === "left" ? -amount : amount,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        const fetchBookmarks = async () => {
            const pubId = publication?.mysqlId;
            const pubType =
                publication?.publicationtype?.subPublicationtypes?.[0]?.name ||
                publication?.publicationtype ||
                null;

            if (!pubId || !pubType) {
                setBookmarks([]);
                return;
            }

            try {
                // // 1️⃣ Önce statusNot dene
                // const res1 = await pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusNot(
                //     pubId,
                //     pubType,
                //     authToken
                // );
                // const data1 = Array.isArray(res1?.data) ? res1.data : [];

                // if (data1.length > 0) {
                //     setBookmarks(data1);
                //     return;
                // }

                // 2️⃣ Eğer boşsa statusTwo dene
                const res2 = await pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusNotMinusOne(
                    pubId,
                    pubType,
                    authToken
                );
                const data2 = Array.isArray(res2?.data) ? res2.data : [];

                if (data2.length > 0) {
                    setBookmarks(data2);
                    return;
                }

                // 3️⃣ İkisinden de data yoksa
                setBookmarks([]);

            } catch (e) {
                console.error("fetchBookmarks error:", e);
                setBookmarks([]);
            }
        };

        fetchBookmarks();
    }, [publication?.mysqlId, publication?.publicationtype, authToken]);


    const openPdfAtPage = (page) => {
        if (!publication?.mysqlId || !page) return;
        // sadece bu yayın için geçerli olacak şekilde sessionStorage’a bırak
        sessionStorage.setItem(`pdf:jump:${publication.mysqlId}`, String(page));
        // OpenAccess'e göre doğru viewer'ı aç
        const hasPdf = !!publication?.pdffile;
        if (!hasPdf) return; // pdf yoksa çık
        const isOpenAccess = Number(publication?.openaccess) === 1;
        const href = isOpenAccess
            ? `/view-pdf-protectedaccess/${publication.mysqlId}`
            : `/view-pdf/${publication.mysqlId}`;
        window.open(href, "_blank", "noopener,noreferrer");
    };


    // Yayıncı adı (öncelik: publishers[], sonra "Yayıncı Şirket Bilgileri")
    const publisher =
        publication?.publishers?.[0]?.title ||
        publication?.publishers?.[0]?.name ||
        getAttr(publication, "Yayıncı Şirket Bilgileri") ||
        null;

    // İçindekiler
    const toc = Array.isArray(publication?.chapters) ? publication.chapters : [];

    // Veritabanları (id→isim)
    const [databaseNames, setDatabaseNames] = useState(null);
    useEffect(() => {
        const fetchAllDatabases = async () => {
            const list = publication?.databases;
            if (!Array.isArray(list) || list.length === 0) {
                setDatabaseNames(null);
                return;
            }
            try {
                const res = await axiosInstance.get(
                    "databases/search/databaseList/1",
                    { headers: { Authorization: `Bearer ${authToken}` } }
                );
                const all = res.data?.data || [];
                const names = list
                    .map(db => {
                        const dbObj = all.find(d => d.id === db.mysqlId);
                        const name = dbObj?.name || dbObj?.title || db.name || db.title || (typeof db === "string" ? db : null);
                        if (!name) return null;
                        const lowerName = name.toLowerCase();
                        if (lowerName.includes("akademik dergiler") || lowerName.includes("popüler dergiler")) {
                            return "İdealonline süreli yayınlar";
                        }
                        return name;
                    })
                    .filter(Boolean);
                setDatabaseNames(names.length ? [...new Set(names)] : null);
            } catch {
                setDatabaseNames(null);
            }
        };
        fetchAllDatabases();
    }, [publication, authToken]);

    // Tabs
    const [activeTab, setActiveTab] = useState("about");
    const tabPane = (isActive) => `tab-pane fade${isActive ? " show active" : ""}`;

    // Anahtar kelime tıklama işlevi
    const handleKeywordClick = (keyword) => {
        navigate(`/publication-list?keywords=${encodeURIComponent(keyword)}`);
    };

    // Künye satırlarını tek yerden yönet
    const rows = [
        ["Editör(ler)", editor],
        ["Yayına Hazırlayan", preparedBy],
        ["Yayıncı", publisher],
        ["Yayın Tarihi", pubDate],
        ["Yayın Dili", language],
        ["Ülke", country],
        ["Baskı Bilgisi", printInfo],
        ["ISBN", isbn],
        ["e-ISBN", eisbn],
        ["DOI", doi],
        ["Cilt", volume],
        ["Sayfa Sayısı", nonZeroOrNull(pageCount)],
        ["Seri Adı", seriesName],
        ["Seri Numarası", seriesNumber],
        ["Alt Seri Adı", subseriesName],
        ["Alt Seri Numarası", subseriesNumber],
        ["Veritabanı", databaseNames?.join(", ") || null],
    ].filter(([, val]) => !!val); // sadece dolu olanları göster

    const hasToc = ["Akademik Kitap", "Popüler Kitap", "Konferans ve Armağan"].includes(pubtype);

    return (
        <div className="card-body mt-0 mb-0" style={{ width: "100%" }}>
            {/* Üst sekmeler */}
            <ul className="nav nav-tabs mb-2">
                <li className="nav-item">
                    <button
                        className={`nav-link btn-sm small${activeTab === "about" ? " fw-semibold text-primary" : " text-muted"}`}
                        style={{ fontSize: "1em" }}
                        onClick={() => setActiveTab("about")}
                    >
                        {pubtype === "Akademik Kitap" || pubtype === "Popüler Kitap" ? "Kitap Hakkında" : "Yayın Hakkında"}
                    </button>
                </li>
                {hasToc && (
                    <li className="nav-item">
                        <button
                            className={`nav-link btn-sm small${activeTab === "toc" ? " fw-semibold text-primary" : " text-muted"}`}
                            style={{ fontSize: "1em" }}
                            onClick={() => setActiveTab("toc")}
                        >
                            İçindekiler
                        </button>
                    </li>
                )}
            </ul>

            <div className="ms-3">
                {/* TAB: Kitap Hakkında */}
                <div className={tabPane(activeTab === "about")}>
                    {activeSummary && (
                        <>
                            <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                                <h5 className="fw-semibold text-darkfume fs-6 mb-0">Özet / Abstract</h5>
                                {availableSummaries.length > 1 && (
                                    <div className="d-flex gap-1 bg-light p-1" style={{ borderRadius: "20px" }}>
                                        {availableSummaries.map((s) => (
                                            <button
                                                key={s.lang}
                                                className="btn btn-sm"
                                                style={{
                                                    backgroundColor: activeSummaryTab === s.lang ? "#14A077" : "transparent",
                                                    color: activeSummaryTab === s.lang ? "#fff" : "#6c757d",
                                                    fontSize: "0.75em",
                                                    borderRadius: "15px",
                                                    padding: "2px 10px",
                                                    border: "none",
                                                    fontWeight: activeSummaryTab === s.lang ? "600" : "500",
                                                    transition: "all 0.2s",
                                                    textTransform: "uppercase"
                                                }}
                                                onClick={() => setActiveSummaryTab(s.lang)}
                                            >
                                                {s.lang}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="mb-2 text-darkfume">
                                {activeSummary.text}
                            </div>
                            <hr className="my-3 text-darkfume" />
                        </>
                    )}

                    {/* Künye Bilgileri (yalnızca doluysa başlık + satırlar) */}
                    {rows.length > 0 && (
                        <div className="mb-4">
                            <h6 className="fw-semibold mb-2 text-darkfume fs-6">Künye Bilgileri</h6>
                            <div>
                                {rows.map(([label, value]) => (
                                    <div key={label} className="text-darkfume">
                                        <b>{label}:</b> <span>{value}</span>
                                    </div>
                                ))}

                                {/* Anahtar Kelimeler - Künye bilgilerinin içinde */}
                                {keywords && keywords.length > 0 && (
                                    <div className="text-darkfume">
                                        <b>Anahtar Kelimeler:</b>{" "}
                                        <span>
                                            {keywords.map((keyword, index) => (
                                                <span
                                                    key={index}
                                                    style={{ cursor: "pointer", color: "#392C7D" }}
                                                    onClick={() => handleKeywordClick(keyword)}
                                                    onMouseOver={(e) => (e.currentTarget.style.textDecoration = "underline")}
                                                    onMouseOut={(e) => (e.currentTarget.style.textDecoration = "none")}
                                                >
                                                    {index !== 0 && ", "}{keyword}
                                                </span>
                                            ))}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Önerilen Yayınlar — SLIDER versiyonu */}
                    <hr className="my-3 text-darkfume" />
                    {similarPublications && similarPublications.length > 0 && (
                        <div className="mb-4">
                            <h6 className="fw-semibold mb-3 text-darkfume fs-6">Önerilen Yayınlar:</h6>

                            <div style={{ position: "relative" }}>

                                {/* Sol ok */}
                                <button
                                    onClick={() => scrollSlider("left")}
                                    onMouseEnter={() => setHoverLeft(true)}
                                    onMouseLeave={() => setHoverLeft(false)}
                                    style={{
                                        position: "absolute",
                                        left: -10,
                                        top: 105,
                                        transform: "translateY(-50%)",
                                        zIndex: 10,
                                        background: hoverLeft ? "#14A077" : "#fff",
                                        borderRadius: "50%",
                                        width: 36,
                                        height: 36,
                                        border: "1px solid #e5e7eb",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        cursor: "pointer",
                                        color: hoverLeft ? "#fff" : "#14A077",
                                        transition: "all 0.2s ease"
                                    }}
                                >
                                    <FeatherIcon icon="chevron-left" size={20} />
                                </button>

                                {/* Slider alanı */}
                                <div
                                    ref={sliderRef}
                                    style={{
                                        display: "flex",
                                        gap: 20,
                                        overflowX: "hidden",
                                        padding: "10px 0",
                                    }}
                                >
                                    {similarPublications.map((pub, idx) => {
                                        const simTitle = getAttr(pub, "Başlık");
                                        return (
                                            <div
                                                key={pub.mysqlId || idx}
                                                style={{
                                                    minWidth: 120,
                                                    maxWidth: 120,
                                                    textAlign: "center"
                                                }}
                                            >
                                                <Link
                                                    to={`/publication-details/${pub.mysqlId}`}
                                                    style={{ textDecoration: "none", color: "#222" }}
                                                >
                                                    {/* FOTOGRAF KUTUSU — yüksekliği burası belirliyor */}
                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            height: "65%",
                                                            marginBottom: 6,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            overflow: "hidden",     // <--- En önemli kısım
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                pub?.coverimage
                                                                    ? getFilePath(`/publications/search/displayFile/${pub?.mysqlId}/${pub?.coverimage}`)
                                                                    : Video
                                                            }
                                                            alt=""
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "contain",   // <--- boşluğu kaldırır, tam doldurur
                                                                borderRadius: 15,
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Başlık */}
                                                    <div style={{ fontSize: "0.92em", fontWeight: 500, color: "#222" }}>
                                                        {simTitle}
                                                    </div>
                                                </Link>
                                            </div>

                                        );
                                    })}
                                </div>

                                {/* Sağ ok */}
                                <button
                                    onClick={() => scrollSlider("right")}
                                    onMouseEnter={() => setHoverRight(true)}
                                    onMouseLeave={() => setHoverRight(false)}
                                    style={{
                                        position: "absolute",
                                        right: -15,
                                        top: 105,
                                        transform: "translateY(-50%)",
                                        zIndex: 10,
                                        background: hoverRight ? "#14A077" : "#fff",
                                        borderRadius: "50%",
                                        width: 36,
                                        height: 36,
                                        border: "1px solid #e5e7eb",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        cursor: "pointer",
                                        color: hoverRight ? "#fff" : "#14A077",
                                        transition: "all 0.2s ease"
                                    }}
                                >
                                    <FeatherIcon icon="chevron-right" size={20} />
                                </button>

                            </div>
                        </div>
                    )}

                </div>

                {/* TAB: İçindekiler (sadece veri varsa anlamlı) */}
                {hasToc && (
                    <div className={tabPane(activeTab === "toc")}>
                        {bookmarks.length > 0 ? (
                            <BookToc
                                bookmarks={bookmarks}
                                currentPage={null}
                                onJump={openPdfAtPage}
                            />
                        ) : (
                            <div className="text-muted">İçindekiler bulunamadı.</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BookAbout;